const StatusPill = ({ status = "not set" }) => {
  const statusStyles = {
    no_docs: "bg-orange-500 border-orange-500 text-orange-50",
    waiting_for_documents: "bg-orange-500 border-orange-500 text-orange-50",
    waiting_for_bank_statements:
      "bg-orange-500 border-orange-500 text-orange-50",
    waiting_for_payslips: "bg-orange-500 border-orange-500 text-orange-50",
    for_review: "bg-green-500 border-green-500 text-green-50",
    under_review_with_credit: "bg-blue-500 border-blue-500 text-blue-50",
    with_customer: "bg-purple-500 border-purple-500 text-purple-50",
    declined: "bg-red-500 border-red-500 text-gray-50",
    grant_issued: "bg-green-500 border-green-500 text-green-50",
    loan_issued: "bg-green-500 border-green-500 text-green-50",
    test: "bg-gray-500 border-gray-500 text-gray-50",
    default: "bg-gray-500 border-gray-500 text-gray-50", // Default styling
  };

  const statusLabel = {
    no_docs: "no documents",
    waiting_for_documents: "waiting for documents",
    waiting_for_bank_statements: "waiting for bank statements",
    waiting_for_payslips: "waiting for payslips",
    under_review_with_credit: "under review with credit",
    with_customer: "with customer",
    for_review: "for review",
    declined: "declined",
    grant_issued: "grant issued",
    loan_issued: "loan issued",
    test: "test application",
  };

  const appliedStyles = statusStyles[status] || statusStyles.default;
  const appliedLabel = statusLabel[status] || "not set";

  return (
    <div
      data-open="true"
      data-shape="pill"
      className={`relative inline-flex w-max items-center border font-sans font-medium rounded-md data-[shape=pill]:rounded-full text-xs p-0.5 shadow-sm ${appliedStyles}`}
    >
      <span className="font-sans text-current leading-none my-0.5 mx-1.5 uppercase">
        {appliedLabel}
      </span>
    </div>
  );
};

export default StatusPill;
